module.exports = {
    LAN: {
        change_pwd: '修改密码' 
    }
}